<!-- clonado de components/V2/ResourceScroller.MovieBox pero no adaptado totalmente para pictures. damn deadline-->
<template>
    <article
            :class="{placeholder: placeholder}"
            class="picture"
    >
        <div class="img" :style="imgStyle" >
            <span v-if="picture.is_hd" class="hd" >
                HD
            </span>
            <span v-if="picture.length" class="length">
                {{pictureLengthFormatted}}
            </span>
        </div>

    </article>
</template>
<script>
export default {
    props: {
        picture: {
            type: Object,
            required: false,
            validate(value){
                return value !== undefined || this.placeholder;
            }
        },
        placeholder: {
            type: Boolean,
            required: false,
            default: false
        },
    },
    data(){
        return {}
    },
    watch: {},
    computed: {
        pictureLengthFormatted(){
            if(this.picture.length === null){
                return null;
            }

            let videoDuration = (new Date(this.picture.length * 1000)).toUTCString().match(/(\d\d:\d\d:\d\d)/)[0];

            if (videoDuration.startsWith('00:')){
                return videoDuration.substr(3, videoDuration.length);
            }else{
                return videoDuration;
            }

        },
        imgStyle(){
            //width:  this.picture.dimentions.width + 'px',
            let image = "";

            if (this.picture.image_path){
                image = this.picture.image_path;
            } else {
                image = this.picture.public_thumbnail_image_path;
            }

            let w = this.picture.dimentions.width;
            let h = this.picture.dimentions.height;

            if (!w || !h) {
                w = 1; h = 1;
            }

            return {
                width: '100%',
                aspectRatio: w + ' / ' + h,
                backgroundImage: `url('${image['large']}')`,
                backgroundPosition: 'center',
            };
        },
    }
}
</script>
<style scoped lang="scss">
@import '../../../styles/variables';

.picture{
    flex-grow: 0;
    flex-basis: 0;
    transition: width .5s ease;
    width: 100%;
    
    .img{
        position: relative;
        background-size: contain;
        background-position-x: center;
        background-position-y: top;
        background-repeat: no-repeat;
        margin-bottom: .5em;
        transition: height .5s ease;
        max-height: 90vh;

        img{
            width: 100%;
            visibility: hidden;
        }

        span.hd{
            position: absolute;
            left: 5px;
            top: 5px;
            padding: 3px;
            font-weight: bold;
            border-radius: 2px;
            background-color: var(--pallete_dark_color);
            color: #ffffff;
        }

        span.length{
            position: absolute;
            right: 5px;
            bottom: 5px;
            padding: 3px;
            border-radius: 2px;
            font-size: 13px;
            background-color: var(--pallete_dark_color);
            color: #ffffff;
        }

        .preview-wrapper{
            opacity: 0;
            transition:opacity .30s linear;

            &.active{
                opacity: 1;
            }
        }

        .preview-wrapper.active{

            .preview{
                background-color: var(--pallete_dark_color);
                position: absolute;
                overflow: hidden;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;

                video{
                    /*object-fit: cover;*/
                    overflow:hidden;
                    min-width: 100%;
                    min-height: 100%;
                }
            }

            .preview-unavailable{
                position: absolute;
                top:0;
                left: 0;
                height: 100%;
                width: 100%;
                background-color: rgba(0,0,0,.25);
            }
        }
    }

    &.placeholder{
        .img{
            background-color: rgba(128,128,128,.25);
        }

        .text{

            .description{
                background-color: rgba(128,128,128,.25);
                height: 1em;
            }

            .name{
                background-color: rgba(128,128,128,.25);
                height: 1em;
            }
        }
    }

    .locked{
        z-index: 1;
    
        &:after{
            content: "";
            background: var(--background);
            background-repeat: no-repeat;
            background-position: center;
            background-size: cover;
            opacity: 0.4;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            position: absolute;
            z-index: -1;
        }
    
        img{
            width: 100%;
            visibility: hidden;
            max-height: 95vh;
        }
    
        .lock{
            display: block;
            width: 100%;
            height: 100%;
            background-image: url('/img/lock-white.png');
            background-size: 100px;
            background-repeat: no-repeat;
            background-position: center;
        }
    }
}
</style>